import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import IconButton from "@mui/material/IconButton";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import PrimaryButton from "../../../components/common/PrimaryButton";
import ImageUpload from "../../../components/forms/imageUpload";
// components
import TextArea from "../../../components/forms/textarea";
// typings
import {
  EFeePayee,
  ItemDetailsDTO,
} from "../../../setup/api/services/contract/models";
import { handleCompressImage } from "../../../setup/util/helpers";
// newTransaction
import newTransaction from "./newTransaction.module.scss";

interface Props {
  handleStepOne: (title: string, description: string, images: File[]) => void;
  title?: string;
  desc?: string;
  // feePayee?: EFeePayee;
  // inspectionPeriod?: number;
  // deliveryInDays?: number;
  imageFiles?: File[];
  s3ImageFiles?: string[];
  handleS3ImageDelete?: (index) => void;
}

const AddProductForm: React.FC<Props> = ({
  handleStepOne,
  title = "",
  desc = "",
  imageFiles = [],
  s3ImageFiles,
  handleS3ImageDelete,
}: Props) => {
  const [images, setImages] = useState<File[]>([]);

  const [ioAuxiliary, setIoAuxilairy] = useState<ItemDetailsDTO["title"]>("");
  const [description, setDescription] =
    useState<ItemDetailsDTO["description"]>("");
  const { t } = useTranslation();

  useEffect(() => {
    if (title) setIoAuxilairy(title);
  }, [title]);

  useEffect(() => {
    if (desc) setDescription(desc);
  }, [desc]);

  useEffect(() => {
    if (imageFiles) setImages(imageFiles);
  }, [imageFiles]);

  const handleImageUpload = async (e: any) => {
    const tempImages = [...images];
    const allowedFormats = [
      "image/x-png",
      "image/jpeg",
      "image/jpg",
      "image/webp",
      "image/png",
    ];
    try {
      const totalImages =
        e?.target?.files?.length > 10 ? 10 : e?.target?.files?.length;
      for (let i = 0; i < totalImages; i++) {
        const file = e?.target?.files[i];
        if (allowedFormats.indexOf(file?.type) === -1) {
          return;
        }
        const image = await handleCompressImage(file);
        image && tempImages.push(image);
      }
      setImages(tempImages);
    } catch (error) {
      console.error(error);
    }
  };

  const handleDeleteImage = (index: number) => {
    const tempImages = [...images];
    tempImages.splice(index, 1);
    setImages(tempImages);
  };

  return (
    <div className={newTransaction["form"]}>
      <div className={newTransaction["top_section"]}>
        <h3 className={newTransaction["form-header"]}>{t("ADD_PRODUCT")}</h3>
        <div style={{ marginBottom: "1rem", width: "100%" }}>
          <TextArea
            label={t("IO_AUXILIARY")}
            defaultValue={title}
            maxCharacters={50}
            required={true}
            height={"4.2rem"}
            handleChange={(e) => setIoAuxilairy(e.target.value)}
          />
        </div>
        <TextArea
          label={t("PRODUCT_DESCRIPTION")}
          required={false}
          defaultValue={desc}
          maxCharacters={500}
          height={"7.43rem"}
          handleChange={(e) => setDescription(e.target.value)}
        />
        <h3 className={newTransaction["form-header"]}>{t("ATTACH_PHOTOS")}</h3>
        <div className={newTransaction["form-scroll"]}>
          {images?.length < 10 && (
            <div key={0} style={{ marginBottom: "0.2rem" }}>
              <ImageUpload handleChange={handleImageUpload} />
            </div>
          )}
          {s3ImageFiles?.map((image, index) => (
            <div
              key={index}
              className={newTransaction["uplaoded_image_container"]}>
              <img className={newTransaction["uploaded_image"]} src={image} />
              <IconButton
                onClick={() => {
                  if (handleS3ImageDelete) handleS3ImageDelete(index);
                }}
                className={newTransaction["delete_icon"]}
                aria-label="delete picture">
                <DeleteOutlineOutlinedIcon className={newTransaction["icon"]} />
              </IconButton>
            </div>
          ))}
          {images?.map((image, index) => (
            <div
              key={index}
              className={newTransaction["uplaoded_image_container"]}>
              <img
                className={newTransaction["uploaded_image"]}
                src={URL.createObjectURL(image)}
              />
              <IconButton
                onClick={() => handleDeleteImage(index)}
                className={newTransaction["delete_icon"]}
                aria-label="delete picture">
                <DeleteOutlineOutlinedIcon className={newTransaction["icon"]} />
              </IconButton>
            </div>
          ))}
        </div>
      </div>
      <div className={newTransaction.bottom_section}>
        <PrimaryButton
          style={{ marginTop: "20px" }}
          id={`create_contract_add_product`}
          onClick={() => handleStepOne(ioAuxiliary, description, images)}
          disabled={
            ioAuxiliary.trim() === "" ||
            ioAuxiliary?.length > 50 ||
            (description !== "" && description?.length > 500)
          }>
          {t("TRACKING")}
        </PrimaryButton>
      </div>
    </div>
  );
};

export default AddProductForm;
